// @ts-ignore TODO: Create types declaration for soundcloud
import SC from 'soundcloud';
import {
  PlatformController,
  MetaData,
  ObsidianActionHooks,
  PlatformState,
} from '../types';
import {Platform} from '../../../types';

export default class SoundCloudController implements PlatformController {
  private sc: any;
  private player: any;
  private clientId?: string;
  private initialized: boolean;
  private actions: ObsidianActionHooks;

  constructor(actions: ObsidianActionHooks) {
    this.initialized = false;
    this.actions = actions;
  }

  private attachPlayerEvents(player: any) {
    this.player = player;
    player.on('play-start', () => {
      this.actions.onPlay();
    });
    player.on('pause', () => {
      console.log('soundcloud player event: pause');
      this.actions.onPause();
    });
    player.on('resume', () => {
      console.log('soundcloud player event: resume');
    });
    player.on('finish', () => {
      console.log('soundcloud player event: finish');
    });
  }

  play(id: string) {
    try {
      this.sc.stream(`/tracks/${id}`).then((player: any) => {
        this.attachPlayerEvents(player);
        player.play();
        this.actions.onMetaDataChange({
          name: id,
          duration: 69,
          artist: ['SoundCloud Artist'],
          albumImage:
            'https://i7.pngguru.com/preview/183/887/625/soundcloud-computer-icons-logo-soundcloud-logo.jpg',
        });
      });
    } catch (error) {
      console.log(
        'soundcloud controller: error while attempting to play track:',
      );
      console.log(error);
    }
  }

  pause() {
    console.log('soundcloud controller: pause');
    try {
      this.player.pause();
    } catch (error) {
      console.log(
        'soundcloud controller: error while attempting to play track:',
      );
      console.log(error);
    }
  }

  resume() {
    this.sc && console.log('soundcloud controller: resume');
  }

  togglePlay() {
    console.log('soundcloud controller: togglePlay');
    try {
      const playState = this.player.getState();
      if (playState === 'paused') {
        this.player.play();
        this.actions.onPlay();
      } else if (playState === 'playing') {
        this.player.pause();
        this.actions.onPause();
      } else if (playState === 'finish') {
        this.player.kill();
      } else if (playState === 'error') {
        const err = {
          message: 'Unhandled SoundCloud playstate',
        };
        this.actions.onBadPlayerState(err.message);
        throw err;
      }
    } catch (error) {
      console.log('error while attempting to play track:');
      console.log(error);
    }
  }

  seek(position: number) {
    console.log(`soundcloud: seek: ${position}`);
  }

  async stop() {}

  nextTrack() {
    try {
      // TODO: Bug: Skip songs very fast until a spotfy song once player controls appear. Soundcloud plays in background
      // SC player isn't killed.
      this.player.kill();
    } catch (err) {
      console.log(`soundcloud controller error when killing player: ${err}`);
    }
    this.sc && console.log('soundcloud: nextTrack');
  }

  previousTrack() {
    this.sc && console.log('soundcloud: previous track');
  }

  setVolume(value: number) {
    this.sc && console.log('soundcloud: setVolume');
  }

  isReady() {
    return this.initialized;
  }

  initialize(clientId: string) {
    this.clientId = clientId;
    this.sc = SC;

    try {
      // TODO: Can we wrap this in a promise / otherwise confirm SC is ready before calling onConnected?
      this.sc.initialize({
        client_id: this.clientId,
      });
    } catch (error) {
      console.log(error);
    }
    this.initialized = false;
    this.actions.onConnected(Platform.Soundcloud);
    return this.initialized;
  }

  // TODO: Can we get metadata from a track id? Otherwise must use search API.
  // Look into SDK's resolve fn
  getTrackMetaData(state: any): MetaData | null {
    return null;
  }

  getState(): PlatformState {
    return {
      platform: Platform.Soundcloud,
      linked: true, // TODO: Is there a case where SoundCloud won't be linked? Option to remove SoundCloud support?
      connected: Boolean(this.sc),
    };
  }
}
